<template>
  <teleport to="body">
  <div v-if="openConfirm" class="modal">
    <div class="wrapper">
      <div class="content">
        <font-awesome-icon class="exit" icon="fa-xmark" @click="close" />

        <h2 class="title">{{ this.message }}</h2>
        <input v-if="isCreateConfirm" v-model="inputValue" type="text" placeholder="Type here..." :class="errorStatus ? 'error-border' : ''" />
        <div class="error">{{ errorMessage }}</div>
        <sub v-if="subMsg"> {{ subMsg }}</sub>
        <div class="actions">
          <button class="cancel" @click.prevent.stop="close">Cancel</button>
          <button class="primary" :class="isDeleteConfirm ? 'danger' : 'action'" @click.prevent.stop="complete">Confirm</button>
        </div>
      </div>
    </div>
  </div>
  </teleport>
</template>

<script>

export default {
  name: "ConfirmModal",
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      required: false,
    },
    isDeleteConfirm: {
      type: Boolean,
      required: false,
      default: false,
    },
    subMsg: {
      type: String,
      required: false,
      default: null,
    },
    isCreateConfirm: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["confirmModal", "close"],
  data() {
    return {
      openConfirm: false,
      inputValue: null,
      errorMessage: "",
      errorStatus: false,
    };
  },

  methods: {
    complete() {
      if (this.isCreateConfirm) {
        if (!this.inputValue) {
          this.errorStatus = true;
          this.errorMessage = "Input cannot be empty.";
          return;
        }
        this.$emit("confirmModal", this.inputValue);
        this.close();
        return;
      } else {
        this.$emit("confirmModal", true);
      }
    },
    close() {
      this.errorStatus = false;
      this.errorMessage = "";
      this.inputValue = null;
      this.openConfirm = false;
      this.$emit("close");
    },
  },

  watch: {
    open() {
      this.openConfirm = this.open;
    },
  },
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";
.content {
  display: flex;
  flex-direction: column;
  justify-content: center !important;
  align-items: center !important;
  .title {
    color: var(--text-colour);
    margin: 0.5rem 0 1rem 0;
    text-align: center;
    text-transform: none;
  }
  input {
    margin: 1rem 0 0 0;
    padding: 0.5rem;
    border-radius: 5px;
    border: none;
    background-color: var(--primary-colour);
    color: var(--text-colour);
    width: 100%;
    max-width: 300px;
  }
  .error-border {
    border: 1px solid var(--warning-colour);
  }
  sub {
    color: var(--action-colour);
    margin-bottom: 1rem;
  }
  .actions {
    display: flex;
    justify-content: space-between !important;
    align-items: center !important;
    button {
      width: 10rem;
      margin: 0.5rem 1rem !important;
      cursor: pointer;
    }
    .cancel {
      background-color: var(--tertiary-colour);
      color: var(--text-colour);
    }
    .danger {
      background-color: var(--danger-colour);
      color: var(--secondary-text-colour);
    }
    .action {
      background-color: var(--action-colour) !important;
      border: none;
      color: var(--text-colour);
    }
  }
  .error {
    color: var(--warning-colour);
    margin-bottom: 1rem;
  }
}

@media only screen and (orientation: portrait) {
  .content{
    max-width: 100%;
    // flex-wrap: wrap;
    h2{
      max-width: 80%; 
      min-width: 50%;
    }

    .actions{
      max-width: 100%;
    }
  }
}
</style>
